import { parseISO } from "date-fns";

export function getLogs({
  userId,
  logTypeCode,
  actionTypeCode,
  fromDate,
  toDate,
  pageNumber,
  pageSize,
}) {
  return window.axios
    .get(`/hub/v1/change-logs`, {
      params: {
        userId,
        logTypeCode,
        actionTypeCode,
        fromDate: fromDate ? parseISO(fromDate).toISOString() : null,
        toDate: toDate ? parseISO(toDate).toISOString() : null,
        pageNumber,
        pageSize,
      },
    })
    .then((response) => response.data);
}

export function getLogSearchParams() {
  return window.axios
    .get(`/hub/v1/change-logs/items`)
    .then((response) => response.data);
}
